'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
var _=["\u5E74","\u5B63\u5EA6","\u6708","\u5468","\u65E5","\u5C0F\u65F6","\u5206\u949F","\u79D2","\u6BEB\u79D2","\u5FAE\u79D2"],N=["\u661F\u671F\u65E5","\u661F\u671F\u4E00","\u661F\u671F\u4E8C","\u661F\u671F\u4E09","\u661F\u671F\u56DB","\u661F\u671F\u4E94","\u661F\u671F\u516D"],o=["\u5468\u65E5","\u5468\u4E00","\u5468\u4E8C","\u5468\u4E09","\u5468\u56DB","\u5468\u4E94","\u5468\u516D"],t=["\u4E00\u6708","\u4E8C\u6708","\u4E09\u6708","\u56DB\u6708","\u4E94\u6708","\u516D\u6708","\u4E03\u6708","\u516B\u6708","\u4E5D\u6708","\u5341\u6708","\u5341\u4E00\u6708","\u5341\u4E8C\u6708"],E=["1\u6708","2\u6708","3\u6708","4\u6708","5\u6708","6\u6708","7\u6708","8\u6708","9\u6708","10\u6708","11\u6708","12\u6708"],S=["\u96F6","\u4E00","\u4E8C","\u4E09","\u56DB","\u4E94","\u516D","\u4E03","\u516B","\u4E5D"],T=["","\u5341","\u767E","\u5343","\u4E07","\u5341","\u767E","\u5343","\u4EBF","\u5341","\u767E","\u5343","\u5146","\u5341","\u767E","\u5343","\u4EAC","\u5341","\u767E","\u5343","\u5793"],I=["\u96F6","\u58F9","\u8D30","\u53C1","\u8086","\u4F0D","\u9646","\u67D2","\u634C","\u7396"],c=["","\u62FE","\u4F70","\u4EDF","\u4E07","\u62FE","\u4F70","\u4EDF","\u4EBF","\u62FE","\u4F70","\u4EDF","\u5146","\u62FE","\u4F70","\u4EDF","\u4EAC","\u62FE","\u4F70","\u4EDF","\u5793"];

exports.a = _;
exports.b = N;
exports.c = o;
exports.d = t;
exports.e = E;
exports.f = S;
exports.g = T;
exports.h = I;
exports.i = c;
